class Zaius {
    constructor() {
        this.zaius = window['zaius'] || (window['zaius'] = []);
    }

    subscribe(email, listId = 'newsletter', args = {}) {
        const payload = Object.assign({
            email: email.toLowerCase(),
            list_id: [listId]
        }, args)

        return new Promise(async(resolve, reject) => {
            try {
                await this.zaius.subscribe(payload);

                resolve()
            } catch (error) {
                reject(error)
            }
        })
    }

    identity(email) {
        return new Promise(async(resolve, reject) => {
            try {
                await this.zaius.entity('customer', { email: email });

                resolve()
            } catch (error) {
                reject(error)
            }
        })
    }

    event(name, options) {
        return new Promise(async(resolve, reject) => {
            try {
                await this.zaius.event(name, options);

                resolve()
            } catch (error) {
                reject(error)
            }
        })
    }

    addToCart(productId) {
        return this.event('product', {
            action: 'add_to_cart',
            product_id: productId
        })
    }

    removeFromCart(productId) {
        return this.event('product', {
            action: 'remove_from_cart',
            product_id: productId
        })
    }
}

export default new Zaius()
